/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconFilterLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 24 24">
    <><g>
    <path d="m18 13h-12c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1z" />
</g>
<g>
    <path d="m15 19h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" />
</g>
<g>
    <path d="m21 7h-18c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1z" />
</g></>
  </Icon>
);
};

IconFilterLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGc+PHBhdGggZD0ibTE4IDEzaC0xMmMtLjYgMC0xLS40LTEtMXMuNC0xIDEtMWgxMmMuNiAwIDEgLjQgMSAxcy0uNCAxLTEgMXoiLz48L2c+PGc+PHBhdGggZD0ibTE1IDE5aC02Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDZjLjYgMCAxIC40IDEgMXMtLjQgMS0xIDF6Ii8+PC9nPjxnPjxwYXRoIGQ9Im0yMSA3aC0xOGMtLjYgMC0xLS40LTEtMXMuNC0xIDEtMWgxOGMuNiAwIDEgLjQgMSAxcy0uNCAxLTEgMXoiLz48L2c+PC9zdmc+";
IconFilterLineComponent.Content = `<svg id="Layer_1" enable-background="new 0 0 24 24" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m18 13h-12c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1z"/></g><g><path d="m15 19h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z"/></g><g><path d="m21 7h-18c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1z"/></g></svg>`;

const IconFilterLine = styled(IconFilterLineComponent)``;

export default IconFilterLine;
